const Thoughts = () => (
  <h1>Thoughts</h1>
);

export default Thoughts;
